export const formatCurrency = (amount) => {
  return new Intl.NumberFormat('id-ID', {
    style: 'currency',
    currency: 'IDR',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  }).format(amount || 0);
};

export const formatDate = (date) => {
  if (!date) return '-';
  return new Date(date).toLocaleDateString('id-ID', {
    day: '2-digit',
    month: 'short',
    year: 'numeric'
  });
};

export const formatDateTime = (date) => {
  if (!date) return '-';
  return new Date(date).toLocaleDateString('id-ID', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  });
};

export const getStatusColor = (status) => {
  switch (status) {
    case 'safe':
    case 'active':
    case 'paid':
    case 'completed':
      return 'bg-emerald-50 text-emerald-700 border-emerald-100';
    case 'warning':
    case 'pending':
      return 'bg-amber-50 text-amber-700 border-amber-100';
    case 'critical':
    case 'overdue':
      return 'bg-red-50 text-red-700 border-red-100';
    default:
      return 'bg-slate-50 text-slate-700 border-slate-100';
  }
};

export const getStatusLabel = (status) => {
  const labels = {
    safe: 'Aman',
    active: 'Aktif',
    paid: 'Lunas',
    completed: 'Selesai',
    warning: 'Waspada',
    pending: 'Pending',
    critical: 'Kritis',
    overdue: 'Jatuh Tempo',
    closed: 'Ditutup'
  };
  return labels[status] || status;
};